module.exports = __webpack_public_path__ + "static/selector-c4ae1c6ebe5adabb3044857ec97f68e3.png";